import { WEBUILogs } from "../logging";

/**
 * Created by m.igrachev on 7/20/2017.
 */
export default function(toValidate, expression) {
    //do not need to check undefined and empty string
    if (!toValidate || toValidate === "") {
        return true;
    }
    //allow validation on all js primitive types
    if (typeof toValidate === "object") {
        WEBUILogs.log("Only primitive types can be matched to regular expression");
        return true;
    }
    //as evaluate them to string
    toValidate = toValidate.toString();

    let trueExpression = expression;
    if (typeof expression === "object") {
        //In case we receive options object literal we take expression from it!
        trueExpression = expression.regExp;
    }
    let regularExpression = new RegExp(trueExpression);
    return !!toValidate.match(regularExpression);
}
